import React, { useState, useEffect } from 'react';
import withRouter from 'with-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Trans, withTranslation, useTranslation } from 'react-i18next';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import InputBase from '@mui/material/InputBase';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import FilterListIcon from '@mui/icons-material/FilterList';
import Chip from '@mui/material/Chip';
import Select from '@mui/material/Select';
import CloseIcon from '@mui/icons-material/Close';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Badge from '@mui/material/Badge';
import SortSharpIcon from '@mui/icons-material/SortSharp';
import Box from '@mui/material/Box';
import { _clearUnchangedFields, _getValidationPropsFromValidations } from '../helper';




const styles = {
    formControl: {
      margin: 0,
      marginLeft: '8px',
      minWidth: 120,
    },
    selectEmpty: (theme) => ({
      marginTop: theme.spacing(2),
    }),
    menuPaper: {
      //maxHeight: 300
    },
    menuItem: {
      //height: 800
    },

    queryFilterRoot: {
      flex: '3'
    },
    closeIcon: {
      position: 'absolute',
      left: 0,
      top: 12,
      backgroundColor: 'background.paper',
      cursor: 'pointer'
    },
    text: {
      marginRight: '16px'
    },
    textInput: {

    },

    optionsFilterRoot: {
      flex: 0,
      marginRight: 8
    },

    sortFilterRoot: {
      flex: 0
    },
  };


let FilterOptionsObject = {
  definition_type: null,
  //sort_key: 'updated_at',
  //search: {
  //  display_name: '',
  //  updated_at: ''
  //},
};





/**
 * 
 * @param {*} props 
 * @returns 
 */
export const FilterOptionsQuery = (props) => {
  let inputTimeout = null;
  const { t } = useTranslation();
  const [query, setQuery] = React.useState('');
  const [initialItem, setInitialItem] = React.useState('');

  // ComponentDidMount
  useEffect(() => {
    setQuery(props.initialItem);
    setInitialItem(props.initialItem);
  }, [])

  const handleChange = (event) => {
    FilterOptionsObject.search = {
      display_name: event.target.value,
      updated_at: ""
    }
    setQuery(event.target.value);
    if(inputTimeout) {
      clearTimeout(inputTimeout)
    }
    inputTimeout = setTimeout(() => {
      props.onChange(FilterOptionsObject);
      closeOpenItem();
    }, 1000);
  };

  const handleResetQuery = (event) => {
    FilterOptionsObject.search = {
      display_name: "",
      updated_at: ""
    }
    props.onChange(FilterOptionsObject);
    setQuery('');

    if(initialItem) {
      setInitialItem(null);
      closeOpenItem();
    }
  }

  const closeOpenItem = () => {
    let uriParts = window.location.pathname.split('/');
    let id = uriParts[3] ? uriParts[3] : uriParts[2];
    if(id) {
      props.history.push(`/${uriParts[1]}`);
    }
  }

  return (
    <span style={styles.queryFilterRoot}>
      <FormControl
        sx={styles.formControl}
        style={{width: '100%'}}>
        {props.hideFilterbar ?
          <Typography variant="subtitle1" color="text.secondary">
            {props.toolbarTitle ? props.toolbarTitle : 'Metadata'}
          </Typography>
        :
          <React.Fragment>
            <TextField
              style={{ margin: 0, paddingRight: 16 }}
              onChange={handleChange}
              value={query}
              placeholder={t(props.placeholderKey || 'itemsList.filterPlaceholderText')}
              fullWidth
              // no underline: the other sections' search box is a bare input
              variant="standard"
              InputProps={{
                disableUnderline: true,
                startAdornment: <SearchOutlinedIcon style={{opacity: .5, marginRight:10}} />,
                sx: {
                  ...styles.text,
                  '& input': styles.textInput
                }
              }} />
            {query &&
              <Box component="span" sx={styles.closeIcon}>
                <CloseIcon onClick={handleResetQuery}/>
              </Box>
            }
          </React.Fragment>
        }
      </FormControl>
    </span>
  );
};





/**
 * Generic filter select component
 * @param {Object} props Component props
 * @param {Array} props.options - Array of {type, name} objects (REQUIRED)
 * @param {Function} props.onChange - Callback function (REQUIRED)
 * @param {Object} props.history - Router history (REQUIRED)
 * @param {string} props.initialValue - Pre-selected value (default: '')
 * @param {string} props.placeholder - Placeholder text when empty (default: 'Select option')
 * @param {boolean} props.showEmptyOption - Whether to show empty option (default: true)
 * @param {string|null} props.emptyOptionLabel - Custom label for empty option (default: null = italic placeholder)
 * @param {string} props.filterKey - Property name in FilterOptionsObject (default: 'definition_type')
 * @param {boolean} props.enablePagination - Enable load more functionality (default: false)
 * @param {Function} props.onLoadMore - Callback for loading more options (optional)
 * @param {string} props.labelId - Custom label ID (optional)
 * @param {string} props.selectId - Custom select ID (optional)
 * @returns
 */
export const FilterOptionsSelect = (props) => {
  const {
    // Core props
    options,
    onChange,
    history,

    // Configuration props (optional with defaults)
    initialValue = '',
    placeholder = 'Select option',
    showEmptyOption = true,
    emptyOptionLabel = null,

    // Filter object property name
    filterKey = 'definition_type',

    // Pagination (optional)
    enablePagination = false,
    onLoadMore = null,

    // Styling (optional)
    labelId = 'filter-select-label',
    selectId = 'filter-select',
  } = props;

  const [value, setValue] = React.useState(initialValue);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  // Only enable pagination if explicitly requested AND callback provided
  const paginationEnabled = enablePagination && typeof onLoadMore === 'function';

  useEffect(() => {
    if (!paginationEnabled) return;

    const loadMoreOptions = async () => {
      setIsLoading(true);
      onLoadMore();
      setIsLoading(false);
    };

    loadMoreOptions();
  }, [page, paginationEnabled, onLoadMore]);

  const handleChange = (event) => {
    const newValue = event.target.value;
    setValue(newValue);
    FilterOptionsObject[filterKey] = newValue;
    onChange(FilterOptionsObject);
    closeOpenItem();
  };

  const handleOpen = () => {
    if (paginationEnabled && onLoadMore) {
      onLoadMore();
    }
  };

  const handleScroll = event => {
    if (!paginationEnabled) return;

    const target = event.target;
    if (target.scrollHeight - target.scrollTop === target.clientHeight) {
      setPage(prevPage => prevPage + 1);
    }
  };

  const closeOpenItem = () => {
    let uriParts = window.location.pathname.split('/');
    let id = uriParts[3] ? uriParts[3] : uriParts[2];
    if(id) {
      history.push(`/${uriParts[1]}`);
    }
  }

  return (
    <span style={styles.optionsFilterRoot}>
      <FormControl sx={styles.formControl}>
        <Select
          labelId={labelId}
          id={selectId}
          value={value}
          displayEmpty={true}
          // closed: the placeholder invites a choice even when the empty entry carries its own label
          renderValue={(selected) => selected === '' ? <em>{placeholder}</em> : ((options || []).find(option => option.type === selected)?.name ?? selected)}
          onChange={handleChange}
          onScroll={paginationEnabled ? handleScroll : undefined}
          onOpen={paginationEnabled ? handleOpen : undefined}
          sx={{ '& .MuiSelect-select': styles.menuPaper }}
          MenuProps={{
            PaperProps: {
              sx: styles.menuPaper
            }
          }}>
          {/* Optional empty option */}
          {showEmptyOption && (
            <MenuItem sx={styles.menuItem} value="">
              {emptyOptionLabel ? (
                emptyOptionLabel
              ) : (
                <em>{placeholder}</em>
              )}
            </MenuItem>
          )}

          {/* Actual options */}
          {options && options.map((option) => (
            <MenuItem sx={styles.menuItem} key={`${option.type}-${option.name}`} value={option.type}>
              {option.name}
            </MenuItem>
          ))}

          {/* Loading indicator (only if pagination enabled) */}
          {paginationEnabled && isLoading && (
            <MenuItem disabled>Loading...</MenuItem>
          )}
        </Select>
      </FormControl>
    </span>
  );
};





/**
 * 
 * @param {*} props 
 * @returns 
 */
export const FilterOptionsSort = (props) => {
  // same look as the item list's toolbar: the sort icon opens a menu of the options; a dot on the
  // icon says the order is not the default one
  const { t } = useTranslation();
  const [sort, setSort] = React.useState(props.initialValue);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleSelect = (value) => {
    setAnchorEl(null);
    if(value === sort) return;
    setSort(value);
    FilterOptionsObject.sort_key = value;
    props.onChange(FilterOptionsObject);
    closeOpenItem();
  };

  const closeOpenItem = () => {
    let uriParts = window.location.pathname.split('/');
    let id = uriParts[3] ? uriParts[3] : uriParts[2];
    if(id) {
      props.history.push(`/${uriParts[1]}`);
    }
  }

  return (
    <span style={styles.sortFilterRoot}>
      <Tooltip title={t('itemsList.sortFieldTooltip')} disableTouchListener disableFocusListener arrow>
        <span>
          <IconButton aria-haspopup="true" aria-label={t('itemsList.sortFieldTooltip')} onClick={(e) => setAnchorEl(e.currentTarget)} size="large">
            <Badge color="secondary" variant="dot" invisible={sort === props.initialValue}>
              <SortSharpIcon />
            </Badge>
          </IconButton>
        </span>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { sx: { margin: '4px 0 0' } } }}
        disableAutoFocusItem
      >
        {props.options && props.options.map((option) => (
          <MenuItem key={`${option.type}-${option.name}`} selected={option.type === sort} onClick={() => handleSelect(option.type)}>
            {option.name}
          </MenuItem>
        ))}
      </Menu>
    </span>
  );
};
  